import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { styled } from '../../styles';
import { Row } from '../layout';
import { LinkButton } from './link_button';
import { EditButton } from './edit_button';
import { SaveUpdateButton } from './save_update_button';
import { SendNote } from './send_note';
import { ToolbarWrapper } from './styles';
import { TextEmphasisToolset } from './text_emphasis_toolset';
import { TextHeadingDropdown } from './text_heading_dropdown';
import { ListsToolset } from './list_toolset';
import { DividerButton } from './divider_button';
export function PostCallToolbar({ displayModeYn }) {
    const editOrSaveUpdateButton = displayModeYn ? (_jsx(EditButton, { inCallOrPostCall: "post-call" })) : (_jsx(SaveUpdateButton, {}));
    return (_jsxs(ToolbarWrapper, { padding: "0.75rem 1rem", height: "3.625rem", "data-testid": "notes-post-call-toolbar", children: [_jsxs(FormatButtons, { children: [_jsx(TextHeadingDropdown, {}), _jsx(TextEmphasisToolset, { paddingLR: postCallControlPadding }), _jsx(ListsToolset, { paddingLR: postCallControlPadding }), _jsx(DividerButton, {}), _jsx(LinkButton, { paddingLR: postCallControlPadding })] }), _jsxs(ActionButtons, { children: [_jsx(SendNote, {}), editOrSaveUpdateButton] })] }));
}
const postCallControlPadding = '.375rem';
const FormatButtons = styled(Row)();
const ActionButtons = styled(Row)({
    columnGap: '1rem',
    alignItems: 'center',
});
//# sourceMappingURL=post_call_toolbar.js.map